import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { HttpClientService, AdobeAnalyticsService, UtilityService } from 'lib/ng2-sapmp/src/providers';
import { ANALYTICS_CONSTANTS } from 'config';

@Injectable()
export class ReviewService {

  constructor(private http: HttpClient, private httpClientService: HttpClientService,
    private adobeAnalyticsService: AdobeAnalyticsService, private utilityService: UtilityService) { }

  configurations(productSpecificationUrl, requestObject) {
    return this.httpClientService.authorizedPost(productSpecificationUrl, requestObject)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
        this.httpClientService.updateAuthorizationHeaders(res);
        return res.body;
      })
      ,catchError( this.handleError ));
  }

  assignUnassign(assignUnassignUrl, Obj) {
    return this.httpClientService.authorizedPut(assignUnassignUrl, Obj)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res);
        return res.body;
      })
      ,catchError( this.handleError ));
  }

  handleError = (error) => {
    return throwError(error);
  }

  // Review event Scenario
  createAdobeEventProperties(dcmCodes, response: any, status: string, event: string, errorCode?: string, errorText?: string) {
    const dataLayer = {};
    dataLayer[ANALYTICS_CONSTANTS.EVENT_EVENT_CODE] = ANALYTICS_CONSTANTS.EVENT_CODE_ASSIGN_LICENSES;
    if (status === 'SUCCESS') {
      dataLayer[ANALYTICS_CONSTANTS.EVENT_ITEMS] = [];
      for (const dcmCode of dcmCodes) {
        const items = {};
        items['itemSku'] = dcmCode;
        let respArray = [];
        respArray = response.items.filter(data => (data.license &&
          data.license.serviceOfferCode && (data.license.serviceOfferCode === dcmCode)));
        items['itemQty'] = respArray.length;
        /* -- 1802 Adobe changes
        respArray = [];
        respArray = response.items.filter(data => ((data.license &&
          data.license.serviceOfferCode && (data.license.serviceOfferCode === dcmCode)) &&
          (data.statusInfo.status && (data.statusInfo.status === 'COMPLETED'))));
        items['assignedLicenses'] = respArray.length;*/
        dataLayer[ANALYTICS_CONSTANTS.EVENT_ITEMS].push(items);
      }
      dataLayer[ANALYTICS_CONSTANTS.EVENT_SUCCESS_FLAG] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_1;
      dataLayer[ANALYTICS_CONSTANTS.EVENT_ERROR_TYPE] = ANALYTICS_CONSTANTS.EVENT_ERROR_SUCCESS_TYPE;
      dataLayer[ANALYTICS_CONSTANTS.EVENT_STATUS_CODE] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_0;

    } else {
      dataLayer[ANALYTICS_CONSTANTS.EVENT_SUCCESS_FLAG] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_0;
      dataLayer[ANALYTICS_CONSTANTS.EVENT_ERROR_TYPE] = ANALYTICS_CONSTANTS.EVENT_ERROR_FAILURE_TYPE;
      dataLayer[ANALYTICS_CONSTANTS.EVENT_STATUS_CODE] = errorCode;
      // dataLayer[ANALYTICS_CONSTANTS.EVENT_STATUS_MESSAGE] = errorText;
    }
    this.adobeAnalyticsService.tag('event', dataLayer, ANALYTICS_CONSTANTS.EVENT_CODE_ASSIGN_LICENSES, event);
  }
}
